import { Document, Page, Text, View } from "@react-pdf/renderer";
import React from "react";

import dayjs from "dayjs";
import { formatIndianCurrency, getMonthInStringNotOneIndexBased } from "../../../utils/common";
import { logger } from "../../../utils/logger";
import ReportHeader from "../report-header";
import { fonts, reportStyles } from "../report-style";

fonts();
const ESIPdf = ({ esiReportPDFData, esiReportSummary, organizationInfo }) => {
  logger.log(esiReportPDFData, "esiReportPDFData");
  return (
    <>
      <Document>
        <Page size="A4" orientation="landscape" style={reportStyles.page}>
          <View fixed>
            <ReportHeader organizationInfo={organizationInfo} />
            <View style={reportStyles.pdfHeaderTableHeadingwrapper}>
              <View>
                <Text style={reportStyles.pdfHeaderTableHeading}>
                  ESI Report of{" "}
                  {getMonthInStringNotOneIndexBased(esiReportPDFData[0]?.month)}{" "}
                  {esiReportPDFData[0]?.year}
                </Text>
              </View>
              {organizationInfo?.esi_code && (
                <View>
                  <Text style={reportStyles.pdfHeaderTableHeading}>
                    ESI ESTT CODE: {organizationInfo?.esi_code}
                  </Text>
                </View>
              )}
            </View>
          </View>
          <View style={reportStyles.pdfHeaderTable}>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Employee:</Text>
                <Text>
                  {esiReportSummary?.total_employee
                    ? esiReportSummary?.total_employee
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Salaried Employee:</Text>
                <Text>
                  {esiReportSummary?.total_salaried_employees
                    ? esiReportSummary?.total_salaried_employees
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Wages Employee:</Text>
                <Text>
                  {esiReportSummary?.total_wages_employees
                    ? esiReportSummary?.total_wages_employees
                    : "0"}
                </Text>
              </View>
            </View>

            <View style={reportStyles.pdfHeaderTableBx}>
              {/* <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total New In ESI:</Text>
                <Text>0</Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Exit From ESI:</Text>
                <Text>0</Text>
              </View> */}
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Employee On leave:</Text>
                <Text>
                  {esiReportSummary?.total_on_leave_employee
                    ? esiReportSummary?.total_on_leave_employee
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total ESI Member:</Text>
                <Text>
                  {esiReportSummary?.total_esi_member
                    ? esiReportSummary?.total_esi_member
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Non-ESI Member:</Text>
                <Text>
                  {esiReportSummary?.total_non_esi_members
                    ? esiReportSummary?.total_non_esi_members
                    : "0"}
                </Text>
              </View>
            </View>

            

            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Gross:</Text>
                <Text>
                  {/* {esiReportSummary?.total_gross_wages
                    ? Number(esiReportSummary?.total_gross_wages).toFixed(2)
                    : "0"} */}
                  {esiReportSummary?.total_gross_wages
                    ? formatIndianCurrency(Math.round(Number(esiReportSummary.total_gross_wages)))
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total ESI Cover Gross:</Text>
                <Text>
                  {/* {esiReportSummary?.total_not_esi_covered_wages
                    ? Number(
                        esiReportSummary?.total_not_esi_covered_wages
                      ).toFixed(2)
                    : "0"} */}
                  {(esiReportSummary?.total_gross_wages && esiReportSummary?.total_not_esi_covered_wages) ?
                    formatIndianCurrency(Math.round(Number(esiReportSummary?.total_gross_wages - esiReportSummary?.total_not_esi_covered_wages))) : "00"}
                </Text>
              </View>

              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Non-ESI Cover Gross:</Text>
                <Text>
                  {/* {esiReportSummary?.total_not_esi_covered_wages
                    ? Number(
                        esiReportSummary?.total_not_esi_covered_wages
                      ).toFixed(2)
                    : "0"} */}
                  {esiReportSummary?.total_not_esi_covered_wages
                    ? formatIndianCurrency(Math.round(Number(
                      esiReportSummary?.total_not_esi_covered_wages
                    )))
                    : "0"}
                </Text>
              </View>
              
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total ESI Wages:</Text>
                <Text>
                  {/* {esiReportSummary?.total_esi_covered_wages
                    ? Number(esiReportSummary?.total_esi_covered_wages).toFixed(
                      2
                    )
                    : "0"} */}
                  {esiReportSummary?.total_esi_covered_wages
                    ? formatIndianCurrency(Math.round(Number(esiReportSummary?.total_esi_covered_wages)))
                    : "0"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total ESI Arear:</Text>
                <Text>
                  {esiReportSummary?.total_esic_arrear
                    ? Number(esiReportSummary?.total_esic_arrear).toFixed(2)
                    : "0"}
                </Text>
              </View>
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Employee Contribution:</Text>
                <Text>
                {esiReportSummary?.total_esi_employees_contribution
                ? Math.ceil(Number(esiReportSummary.total_esi_employees_contribution))
                : "0"}

                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Employer Contribution:</Text>
                <Text>
                  {/* {esiReportSummary?.total_esi_employeer_contribution
                    ? Number(
                        esiReportSummary?.total_esi_employeer_contribution
                      ).toFixed(2)
                    : "0"
                    } */}
                    {esiReportSummary?.total_esi_covered_wages
                      ? Math.ceil(Number(esiReportSummary.total_esi_covered_wages) * 0.0325)
                      : "0"
                    }


                </Text>
              </View>
            </View>
          </View>
          <View style={reportStyles.ReportTable}>
            <View style={reportStyles.ReportTh} fixed>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "3%", borderRight: "1px solid #ccc" },
                ]}
              >
                SL
              </Text>

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "8%", borderRight: "1px solid #ccc" },
                ]}
              >
                IP NO
              </Text>

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "18%", borderRight: "1px solid #ccc" },
                ]}
              >
                EMPLOYEE NAME
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "12%", borderRight: "1px solid #ccc" },
                ]}
              >
                NO OF WORKING DAYS
              </Text>

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", borderRight: "1px solid #ccc" },
                ]}
              >
                GROSS PAY
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", borderRight: "1px solid #ccc" },
                ]}
              >
                ESI WAGES
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "10%", borderRight: "1px solid #ccc" },
                ]}
              >
                EMPLOYEE CONTRIBUTION
              </Text>
              {/* <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "10%", borderRight: "1px solid #ccc" },
                ]}
              >
                EMPLOYER CONTRIBUTION
              </Text> */}
           
              <Text style={[reportStyles.ReportHeaderCell, { width: "11%" }]}>
                REMARKS
              </Text>
            </View>
            {esiReportPDFData?.length > 0 &&
              esiReportPDFData?.map((data, index) => (
                <>
                  <View style={reportStyles.ReportTd} key={index} wrap={false}>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "3%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{index + 1}</Text>
                    </View>

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "8%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {data?.employees?.esi_insurance_no
                          ? data?.employees?.esi_insurance_no
                          : "--"}
                      </Text>
                    </View>

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "18%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {" "}
                        {data?.employee_name ? data?.employee_name : "--"}
                      </Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "12%", borderRight: "1px solid #ccc", textAlign: "center", },
                      ]}
                    >
                      <Text>
                        {data?.payable_days ? data?.payable_days : "00"}
                      </Text>
                    </View>

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", borderRight: "1px solid #ccc",textAlign: "right", },
                      ]}
                    >
                      <Text>
                        {/* {data?.gross_salary ? data?.gross_salary : "00"} */}
                        {data?.gross_salary ? formatIndianCurrency(data?.gross_salary.toFixed()) : "00"}
                      </Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", borderRight: "1px solid #ccc", textAlign: "right", },
                      ]}
                    >
                      <Text>{data?.esi_wages ?  formatIndianCurrency(data?.esi_wages.toFixed()): "00"}</Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "10%", borderRight: "1px solid #ccc", textAlign: "right", },
                      ]}
                    >
                      <Text>{data?.esi_amount ? formatIndianCurrency(data?.esi_amount.toFixed()) : "00"}</Text>
                    </View>
                    {/* <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "10%", borderRight: "1px solid #ccc", textAlign: "right", },
                      ]}
                    >
                      <Text>
                        {data?.ee_esi_amount ? formatIndianCurrency(data?.ee_esi_amount.toFixed()): "00"}
                      </Text>
                    </View> */}
              
                    <View style={[reportStyles.ReportTdCell, { width: "11%" }]}>
                        <Text style={{width:"100%"}}>
                          {(() => {
                            const joinDate = data?.employees?.join_date ? new Date(data.employees.join_date) : null;
                            const exitDate = data?.employees?.exit_formalities?.[0]?.exit_date ? new Date(data.employees.exit_formalities[0].exit_date) : null;
                            const recordMonth = data?.month;
                            const recordYear = data?.year;

                            if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
                              return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                            }
                            if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
                              return `The Employee exited on ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                            }
                            return data?.remarks || "--";
                          })()}
                        </Text>
                    </View>
                  </View>
                </>
              ))}
          </View>
          <View style={reportStyles.footer} fixed>
            <Text>
              Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")}{" "}
            </Text>
            <Text
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </Page>
      </Document>
    </>
  );
};
export default ESIPdf;
